import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './LegalLayout.module.scss';

interface LegalLayoutProps {
  children: React.ReactNode;
  hero?: React.ReactNode;
}

const LegalLayout: React.FC<LegalLayoutProps> = ({ children, hero }) => {
  const { t } = useTranslation();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      window.history.pushState(null, '', `#${id}`);
    }
  };

  return (
    <div className={styles.legalShell}>
      <main className={styles.legalMain}>
        {hero ? (
          hero
        ) : (
          <section className={styles.legalHero}>
            <section className={styles.legalCard}>
              <div className={styles.legalMeta}>
                <span>{t('legal.meta1', 'Texto de trabajo')}</span>
                <span>{t('legal.meta2', 'Revisión jurídica pendiente')}</span>
              </div>
              <h1 className={styles.legalTitle}>{t('legal.title', 'Información legal')}</h1>
              <p className={styles.legalLead}>
                {t('legal.lead', 'Accedé a los términos, condiciones y políticas que regulan el uso de la plataforma Bodhiwell®. Las aceptaciones específicas del consultante y del profesional se gestionan dentro de cada perfil correspondiente.')}
              </p>
              <div className={styles.legalAnchorNav}>
                <a 
                  href="#terminos" 
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo('terminos');
                  }}
                >
                  {t('landing.footer.termsAndConditions', 'Términos y condiciones')}
                </a>
                <a 
                  href="#privacidad" 
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo('privacidad');
                  }}
                >
                  {t('landing.footer.privacyPolicy', 'Política de privacidad')}
                </a>
                <NavLink 
                  to="/politica-de-cookies" 
                  className={({ isActive }) => (isActive ? styles.active : '')}
                >
                  {t('landing.footer.cookiesPolicy', 'Política de cookies')}
                </NavLink>
              </div>
            </section>
          </section>
        )}

        <div className={styles.legalContent}>
          {children}
        </div>
      </main>
    </div>
  );
};

export default LegalLayout;
